<template>
    <div class="label">
      <div class="header">
        <img src="@/assets/png/logo-label.png" class="logo" />
        <div class="company-info">
          <div class="company-name">RII Express</div>
          <div class="company-address text">14950 Valley View Ave</div>
          <div class="company-address text">La Mirada, CA 90638</div>
          <div class="company-address text">United States (USA)</div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="group-container">
        <span class="group title">{{groupName}}</span>
      </div>
      <div class="divider"></div>
      <div class="container-info">
        <div class="container-no-short title">{{shortContainerNo}}</div>
        <div class="container-no text">{{containerNo}}</div>
      </div>
      <div class="divider"></div>
      <div class="pallet-info">
        <div class="qr-container">
          <img class="pallet-qr" :src="src" />
          <span class="pallet-no text">{{palletNo}}</span>
        </div>
        <div class="boxes-count-container">
          <div class="boxes-count text">Goods Counts</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'PalletLabel',
  props: {
    groupName: {
      type: String,
      required: true
    },
    shortContainerNo: {
      type: String,
      required: true
    },
    containerNo: {
      type: String,
      required: true
    },
    palletNo: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    }
  },
  methods: {
    adjustGroupNameFontSize() {
      const groupNameDom = document.querySelector('.group')
      if (groupNameDom === null) return
      const length = this.groupName.length
      if (length > 9) {
        groupNameDom.style.fontSize = (75 - 1.5 * length) + 'px'
      } else {
        groupNameDom.style.fontSize = '75px'
      }
    }
  },
  watch: {
    groupName: {
      handler() {
        this.adjustGroupNameFontSize()
      },
      immediate: true
    }
  },
  mounted() {
    this.adjustGroupNameFontSize()
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/common.scss';

.label {
    width: 384px;
    height: 576px;
    background-color: #fff;
    padding: 20px;
    @extend .f-c;
    gap: 15px;

    .text {
      font-weight: bold;
      font-size: 14px;
    }

    .title {
      font-weight: bolder;
      font-size: 75px;
    }

    .header {
      @extend .f-r;
      gap: 20px;
      .logo {
        height: 80px;
        margin-top: 3px;
      }
      .company-info {
        .company-name {
          font-weight: bolder;
          font-size: 30px;
        }
      }
    }
    .divider {
      width: 100%;
      height: 2px;
      background-color: #000;
    }
    .group-container {
      @extend .f-r;
      justify-content: center;
    }
    .container-info {
      @extend .f-c;
      align-items: center;
    }
    .pallet-info {
      @extend .f-r;
      gap: 10px;
      .qr-container {
        @extend .f-c;
        align-items: center;
        gap: 12px;
      }
      .boxes-count-container {
        border: solid;
        flex-grow: 1;
        padding: 2px;
      }
    }
  }
</style>
